export default __webpack_public_path__ + "static/media/giants1Klein.02275552.jpg";